import { IArrowPosition } from '@features/cms/typescript';
import theme from '@styles/theme';
export default {
  slideControlField: (direction: 'next' | 'prev', withScrollbar?: boolean) => ({
    display: ['none', 'none', 'none', 'inline-block'],
    position: 'absolute',
    width: 'calc(100vw / 6)',
    zIndex: theme.zIndex.contextMenu,
    top: 0,
    bottom: withScrollbar ? 64 : 0,
    bg: 'transparent',
    border: 'none',
    cursor: 'none',
    ...(direction === 'next' ? {
      right: 0,
      cursor: 'none'
    } : {}),
    ...(direction === 'prev' ? {
      left: 0,
      cursor: 'none'
    } : {})
  }),
  arrowPosition: (position: IArrowPosition) => ({
    position: 'absolute',
    top: position.top,
    left: position.left,
    opacity: position.isVisible,
    transform: 'translate(0, -50%)',
    objectFit: 'contain',
    cursor: 'none'
  })
};